"use client";

import { CheckCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DataCollectionAndUse() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const dataPoints = ["Contact information (name, email, phone number)", "Project specifications and technical requirements", "Service history and maintenance records", "Payment and billing information for invoicing"];
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <Card className="overflow-hidden shadow-medium">
          <CardContent className="p-0">
            <div className="grid gap-8 lg:grid-cols-2 lg:gap-12 p-8 lg:p-12">
              {}
              <div ref={leftRef} className="transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
              opacity: leftVisible ? 1 : 0,
              transform: leftVisible ? "translateX(0)" : "translateX(-20px)"
            }}>
                <h2 className="font-display text-3xl font-bold text-foreground mb-6">
                  What We Collect
                </h2>
                <ul className="space-y-4">
                  {dataPoints.map((point, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                      <CheckCircle className="h-6 w-6 flex-shrink-0 text-primary mt-0.5" aria-hidden="true" />
                      <span className="text-foreground text-base leading-relaxed">
                        {point}
                      </span>
                    </li>)}
                </ul>
              </div>

              {}
              <div ref={rightRef} className="flex flex-col justify-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
              opacity: rightVisible ? 1 : 0,
              transform: rightVisible ? "translateX(0)" : "translateX(20px)"
            }}>
                <h3 className="font-display text-2xl font-semibold text-foreground mb-4">
                  How We Use Your Information
                </h3>
                <div className="space-y-4 text-foreground/90 text-base leading-relaxed">
                  <p>
                    We collect and use your personal information solely to
                    provide you with high-quality welding and fabrication
                    services. Your contact details allow us to communicate
                    project updates, schedule appointments, and respond to
                    inquiries promptly.
                  </p>
                  <p>
                    Project specifications and service history help us deliver
                    accurate quotes, maintain quality standards, and ensure
                    continuity across multiple engagements. Payment information
                    is securely processed for billing purposes only.
                  </p>
                  <p>
                    We never share your data with third parties for marketing
                    purposes and maintain strict confidentiality in accordance
                    with industry best practices and applicable privacy
                    regulations.
                  </p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}